<div class="google-user-container">
  <div class="position-relative pointer" (click)="togglePopup($event)">
    <div *ngIf="misdatos.foto == ''" class="avatar-texto" [style.background-color]="misdatos.color_brand">{{misdatos.first_brand}}</div>
    <img *ngIf="misdatos.foto != ''" class="avatar-usuario" [src]="misdatos.foto">
    <span class="punto-conectado"></span>
  </div>

  @if (isPopupOpen) {
    <div class="google-popup">
      <div class="popup-header">
        <span class="user-email">{{misdatos.username}}</span>
      </div>

      <div class="popup-body">
        <div class="position-relative">
          <div *ngIf="misdatos.foto == ''" class="large-avatar" [style.background-color]="misdatos.color_brand">{{misdatos.first_brand}}</div>
          <img *ngIf="misdatos.foto != ''" class="large-avatar" [src]="misdatos.foto">
          <span class="punto-conectado"></span>
        </div>
        <h2 class="user-name">{{misdatos.first_name}} {{misdatos.last_name}}</h2>
      </div>

      <div class="list-group list-group-flush m-4">
        <a class="pointer list-group-item list-group-item-action disabled" aria-disabled="true"><i class="fa-solid fa-user text-secondary"></i> Mi cuenta</a>
        <a class="pointer list-group-item list-group-item-action" (click)="cerrarSesion()"><i class="fa-solid fa-power-off text-secondary"></i> Cerrar sesión</a>
      </div>
    </div>
  }

</div>